// rxc 
// edf 
// exd 

const SectionDivider = () => {
  return (
    <div className="app__section-divider-comp" />
  )
}
export default SectionDivider